module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('UpdateBanner'), _vm._v(" "), _c('main', {
    attrs: {
      "id": "landing"
    }
  }, [_c('aside', {
    staticClass: "refine"
  }, [_c('h2', [_vm._v("Protocol Library")]), _vm._v(" "), _c('Categories'), _vm._v(" "), _c('CalloutDocs')], 1), _vm._v(" "), _c('section', {
    staticClass: "landing"
  }, [(_vm.featuredProtocols.length > 0) ? _c('h2', {
    attrs: {
      "id": "featured"
    }
  }, [_vm._v("Featured Protocols")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.featuredProtocols), function(protocol) {
    return _c('FeaturedProtocol', {
      attrs: {
        "protocol": protocol
      }
    })
  })], 2)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-dc605fec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LandingView.vue
// module id = 250
// module chunks = 2